import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { SettingIcon, DeleteIcon, PlusSolidIcon, OnStatus, OffStatus } from '../../../../components/Icons/Icons';
import empty from "../../../../assets/images/Emty.png";
import styles from './EditGroup.module.css'
import { sorterArray } from '../../../../utils';
import NameCol from '../../../../components/NameCol';
import RenderStatus from '../../../../components/StatusRender';

const cx = classNames.bind(styles)
const TableCamera = ({ listCamSelect, showModalInfo, handleRemoveCamera, handleClick }) => {
  const [toggleSort, setToggleSort] = useState(false)
  const [dataTable, setDataTable] = useState()
  const [method, setMethod] = useState('')
  const companyCode = sessionStorage.getItem('company_code');
  useEffect(() => {
    const newData = listCamSelect ? [...listCamSelect] : null
    if (newData && method.length > 0) {
      switch (toggleSort) {
        case 'up':
          const dataSortUp = sorterArray(newData, method)
          setDataTable(dataSortUp)
          break;
        case 'down':
          const dataSortDown = sorterArray(newData, method)
          setDataTable(dataSortDown.reverse())
          break;
        default:
          setDataTable(newData)
          break;
      }
    } else {
      setDataTable(newData)
    }
  }, [listCamSelect, toggleSort, method])

  const handleSort = (type, method) => {
    if (type !== toggleSort) {
      setToggleSort(type)
      setMethod(method)
    } else {
      setToggleSort(false)
      setMethod('')
    }
  }
  return (
    <div className={cx("list")}>
      {listCamSelect.length > 0 ? (
        <div
          className={cx("content-table")}
          style={{ padding: "0 16px" }}
        >
          {listCamSelect.length > 0 && (
            <table className={cx("table")}>
              <thead>
                <tr>
                  <th>STT</th>
                  <th>
                    <NameCol active={method} title={'Tên camera'} handleSort={handleSort} method={'NAME_CAM'} />
                  </th>
                  <th>
                    <NameCol active={method} title={'Địa điểm'} handleSort={handleSort} method={'PROVINCE_NAME'} />
                  </th>
                  <th>

                    <NameCol active={method} title={'Độ phân giải'} handleSort={handleSort} method={'MAIN_SOURCE'} />
                  </th>
                  <th>Hành động</th>
                </tr>
              </thead>
              <tbody>
                {dataTable.length > 0 &&
                  dataTable.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          <div style={{
                            display: "flex",
                            gap: 10,
                            alignItems: "center",
                            padding: "14px 0",
                          }}>
                            <span className={cx('On')}>
                              <RenderStatus status={item?.STATUS_ACTIVE} companyCode={companyCode}/>
                            </span>
                            <span style={{ fontSize: 14 }}>
                              {item?.NAME_CAM}
                            </span>
                          </div>
                        </td>

                        <td>{item?.PROVINCE_NAME}</td>
                        <td>{item?.MAIN_SOURCE}</td>
                        <td>
                          <button
                            onClick={(e) => showModalInfo(item?.CODE)}
                          >
                            <SettingIcon />
                          </button>
                          <button
                            onClick={(e) =>
                              handleRemoveCamera(item?.CODE)
                            }
                          >
                            <DeleteIcon />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          )}
        </div>
      ) : (
        <div className={cx("content-faild")}>
          <img src={empty} alt="Không có nội dung tìm kiếm" />
          <p className={cx("description")}>
            Chưa có camera nào trong nhóm
          </p>
        </div>
      )}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <button onClick={handleClick} className={cx("btn-camera")}>
          Thêm camera{" "}
          <span style={{ paddingTop: 2 }}>
            <PlusSolidIcon />
          </span>
        </button>
      </div>
    </div>
  );
};

export default TableCamera;